import { StyledWrapper } from './Wrapper.styles';

function Wrapper({ children }) {
  return <StyledWrapper>{children}</StyledWrapper>;
}

export default Wrapper;
